import React, { useState, useEffect, useRef } from 'react'
import { Spin, Tree } from 'antd'
import { useDispatch } from 'react-redux'
import { useTypedSelector } from '../../redux/store'
import { treeItem, getTreeAction } from './treeReducer'
import { PlusSquareOutlined, MinusSquareOutlined } from '@ant-design/icons'
import './style.scss'
import { MaterialType } from '../../tools/util'
export interface selectNodeParam {
  key: string
  title: string
  level: string
  parentId: string
  categoryTree: string
  canAddProduct: boolean
  prefixCode: string
  frontendHintText?: string // 四级类目前台提示文案
}
interface Props {
  selectNode: (e: selectNodeParam) => void // 参数当前节点，返回需要添加的子节点数据
  selectData?: any
  searchKey?: string // 搜索值
  height?: number // 虚拟滚动高度
  materialType?: MaterialType
  treeList: treeItem[]
}

const CustomTreeAll: React.FC<Props> = (props) => {
  const { selectNode, selectData, searchKey, height, materialType, treeList } =
    props
  const [expandedKeys, setExpandedKeys] = useState<string[]>(['']) // 展开指定节点
  const [autoExpandParent, setAutoExpandParent] = useState<boolean>(true)
  const [selectedKeys, setSelectedKeys] = useState<(string | number)[]>([]) // 当前选中的id
  const dispatch = useDispatch()
  const [dataList, setdataList] = useState<{ id: string; title: string }[]>([])
  const { loading } = useTypedSelector((state) => state.treeReducer)
  // 控制异步请求标识
  const ignore = useRef(false)
  useEffect(() => {
    if (treeList.length === 0 || materialType) {
      // 获取类目树信息
      dispatch(getTreeAction('1'))
    }
    if (selectData) {
      // setExpandedKeys([selectData.id]);
      setSelectedKeys([selectData.id])
    }
    return () => {
      ignore.current = true
    }
    // eslint-disable-next-line
  }, [])
  useEffect(() => {
    if (treeList) {
      getkeynode(treeList)
    }
    // eslint-disable-next-line
  }, [treeList])

  // 获取解析数据
  function getkeynode(data: treeItem[]) {
    for (let i = 0; i < data.length; i++) {
      const node = data[i]
      const { id, name, prefixCode } = node
      const arr = dataList
      const a = { id: id, title: `${name}[${prefixCode}]`.toUpperCase() }
      arr.push(a)
      setdataList([...arr])
      if (node.childList && node.childList.length > 0) {
        getkeynode(node.childList)
      }
    }
  }

  // 搜索
  useEffect(() => {
    const str = searchKey ? searchKey : ''
    const value = str.toUpperCase()
    const expandedKeys = dataList
      .map((item) => {
        if (item.title.indexOf(value) !== -1) {
          return getParentKey(item.id, treeList)
        }
        return null
      })
      .filter((item, i, self) => item && self.indexOf(item) === i)
    // 设置展开指定节点
    if (value) {
      setAutoExpandParent(true)
      setExpandedKeys(expandedKeys)
    }
    setTimeout(()=>{
      const element=document.getElementById('firstSearchResult')
      element?.scrollIntoView()
    },500)
    // eslint-disable-next-line
  }, [searchKey])

  // 获取需要展开的节点
  const getParentKey = (key: string, tree: treeItem[]): any => {
    let parentKey
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i]
      if (node.childList && node.childList.length > 0) {
        // 这里匹配 parentId
        if (node.childList.some((item) => item.id === key)) {
          parentKey = node.id
        } else if (getParentKey(key, node.childList)) {
          parentKey = getParentKey(key, node.childList)
        }
      }
    }
    return parentKey
  }

  // 展开/收起
  const onExpand = (expandedKeys: any) => {
    setExpandedKeys(expandedKeys)
    setAutoExpandParent(false)
  }
  // 渲染 树结构
  const loop = (data: any) => {
    let first = true
    return data.map((item: treeItem) => {
      const str = item.prefixCode
        ? `|${item.prefixCode}| ${item.name}`
        : item.name
      let titleName: any = str.toUpperCase()
      let titleId = ''
      if (searchKey) {
        // 美化选中项
        const str = searchKey.toUpperCase()
        const index = titleName.indexOf(str)
        const beforeStr = titleName.substr(0, index)
        const afterStr = titleName.substr(index + str.length)
        titleName =
          index > -1 ? (
            <>
              {beforeStr}
              <span className="site-tree-search-value ellipsis">{str}</span>
              {afterStr}
            </>
          ) : (
            titleName
          )
        if (first&&index > -1) {
          titleId = 'firstSearchResult'
          first = false
        }
      }
      if (item.childList && item.childList.length > 0) {
        return {
          title: (
            <span
              className="ellipsis"
              style={{ userSelect: 'none' }}
              id={titleId}
            >
              {titleName}
            </span>
          ),
          key: item.id,
          level: item.level,
          name: item.name,
          disabled: false,
          canAddProduct: item.canAddProduct,
          className: 'customtreeall',
          switcherIcon: renderIcon,
          children: loop(item.childList), // 筛选掉不可见的类目.filter(item=>item.canShow)
          prefixCode: item.prefixCode,
          frontendHintText: item.frontendHintText,
        }
      }

      return {
        title: (
          <span
            className="ellipsis"
            style={{ userSelect: 'none' }}
            id={titleId}
          >
            {titleName}
          </span>
        ),
        name: item.name,
        level: item.level,
        key: item.id,
        disabled: false,
        canAddProduct: item.canAddProduct,
        className: 'customtreeall',
        switcherIcon: renderIcon,
        prefixCode: item.prefixCode,
        frontendHintText: item.frontendHintText,
      }
    })
  }
  // 选中tree节点
  const onSelect = (key: (string | number)[], info: any) => {
    setSelectedKeys(key)
    selectNode({
      key: info.node.key,
      title: info.node.name,
      level: info.node.level,
      parentId: info.node.parentId,
      categoryTree: info.node.categoryTree,
      canAddProduct: info.node.canAddProduct,
      prefixCode: info.node.prefixCode,
      frontendHintText: info.node.frontendHintText,
    })
  }

  const gettreeData = () => {
    if (!ignore.current) {
      return [
        {
          title: '全部',
          key: '',
          level: '',
          name: '',
          disabled: false, // 是否禁用、启用
          className: 'customtreeall',
          switcherIcon: renderIcon,
          children: loop(treeList), // 筛选掉不可见的类目.filter(item=>item.canShow)
          prefixCode: '',
        },
      ]
    }
    return []
  }

  const renderIcon = (val: any) => {
    if (!val.data.children || val.data.children.length === 0) {
      return null
    }
    if (val.expanded) {
      return <MinusSquareOutlined />
    }
    return <PlusSquareOutlined />
  }

  return (
    <Spin spinning={loading}>
      <Tree.DirectoryTree
        treeData={gettreeData()} // treeNodes 数据
        height={height}
        onExpand={onExpand} // 展开/收起节点时触发
        expandedKeys={expandedKeys} // （受控）展开指定的树节点
        autoExpandParent={autoExpandParent} // 是否自动展开父节点
        expandAction="doubleClick" // 双击展开
        showIcon={false}
        onSelect={onSelect} // 点击树节点触发
        blockNode={false} // 是否节点占据一行
        selectedKeys={selectedKeys} // 当前选中
      />
    </Spin>
  )
}
export default CustomTreeAll
import React, { useState, useEffect, useRef } from 'react'
import { Spin, Tree } from 'antd'
import { useDispatch } from 'react-redux'
import { useTypedSelector } from '../../redux/store'
import { treeItem, getTreeAction } from './treeReducer'
import { PlusSquareOutlined, MinusSquareOutlined } from '@ant-design/icons'
import './style.scss'
import { MaterialType } from '../../tools/util'
export interface selectNodeParam {
  key: string
  title: string
  level: string
  parentId: string
  categoryTree: string
  canAddProduct: boolean
  prefixCode: string
  frontendHintText?: string // 四级类目前台提示文案
}
interface Props {
  selectNode: (e: selectNodeParam) => void // 参数当前节点，返回需要添加的子节点数据
  selectData?: any
  searchKey?: string // 搜索值
  height?: number // 虚拟滚动高度
  materialType?: MaterialType
  treeList: treeItem[]
}

const CustomTreeAll: React.FC<Props> = (props) => {
  const { selectNode, selectData, searchKey, height, materialType, treeList } =
    props
  const [expandedKeys, setExpandedKeys] = useState<string[]>(['']) // 展开指定节点
  const [autoExpandParent, setAutoExpandParent] = useState<boolean>(true)
  const [selectedKeys, setSelectedKeys] = useState<(string | number)[]>([]) // 当前选中的id
  const dispatch = useDispatch()
  const [dataList, setdataList] = useState<{ id: string; title: string }[]>([])
  const { loading } = useTypedSelector((state) => state.treeReducer)
  // 控制异步请求标识
  const ignore = useRef(false)
  useEffect(() => {
    if (treeList.length === 0 || materialType) {
      // 获取类目树信息
      dispatch(getTreeAction('1'))
    }
    if (selectData) {
      // setExpandedKeys([selectData.id]);
      setSelectedKeys([selectData.id])
    }
    return () => {
      ignore.current = true
    }
    // eslint-disable-next-line
  }, [])
  useEffect(() => {
    if (treeList) {
      getkeynode(treeList)
    }
    // eslint-disable-next-line
  }, [treeList])

  // 获取解析数据
  function getkeynode(data: treeItem[]) {
    for (let i = 0; i < data.length; i++) {
      const node = data[i]
      const { id, name, prefixCode } = node
      const arr = dataList
      const a = { id: id, title: `${name}[${prefixCode}]`.toUpperCase() }
      arr.push(a)
      setdataList([...arr])
      if (node.childList && node.childList.length > 0) {
        getkeynode(node.childList)
      }
    }
  }

  // 搜索
  useEffect(() => {
    const str = searchKey ? searchKey : ''
    const value = str.toUpperCase()
    const expandedKeys = dataList
      .map((item) => {
        if (item.title.indexOf(value) !== -1) {
          return getParentKey(item.id, treeList)
        }
        return null
      })
      .filter((item, i, self) => item && self.indexOf(item) === i)
    // 设置展开指定节点
    if (value) {
      setAutoExpandParent(true)
      setExpandedKeys(expandedKeys)
    }
    setTimeout(()=>{
      const element=document.getElementById('firstSearchResult')
      element?.scrollIntoView()
    },500)
    // eslint-disable-next-line
  }, [searchKey])

  // 获取需要展开的节点
  const getParentKey = (key: string, tree: treeItem[]): any => {
    let parentKey
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i]
      if (node.childList && node.childList.length > 0) {
        // 这里匹配 parentId
        if (node.childList.some((item) => item.id === key)) {
          parentKey = node.id
        } else if (getParentKey(key, node.childList)) {
          parentKey = getParentKey(key, node.childList)
        }
      }
    }
    return parentKey
  }

  // 展开/收起
  const onExpand = (expandedKeys: any) => {
    setExpandedKeys(expandedKeys)
    setAutoExpandParent(false)
  }
  // 渲染 树结构
  const loop = (data: any) => {
    let first = true
    return data.map((item: treeItem) => {
      const str = item.prefixCode
        ? `|${item.prefixCode}| ${item.name}`
        : item.name
      let titleName: any = str.toUpperCase()
      let titleId = ''
      if (searchKey) {
        // 美化选中项
        const str = searchKey.toUpperCase()
        const index = titleName.indexOf(str)
        const beforeStr = titleName.substr(0, index)
        const afterStr = titleName.substr(index + str.length)
        titleName =
          index > -1 ? (
            <>
              {beforeStr}
              <span className="site-tree-search-value ellipsis">{str}</span>
              {afterStr}
            </>
          ) : (
            titleName
          )
        if (first&&index > -1) {
          titleId = 'firstSearchResult'
          first = false
        }
      }
      if (item.childList && item.childList.length > 0) {
        return {
          title: (
            <span
              className="ellipsis"
              style={{ userSelect: 'none' }}
              id={titleId}
            >
              {titleName}
            </span>
          ),
          key: item.id,
          level: item.level,
          name: item.name,
          disabled: false,
          canAddProduct: item.canAddProduct,
          className: 'customtreeall',
          switcherIcon: renderIcon,
          children: loop(item.childList), // 筛选掉不可见的类目.filter(item=>item.canShow)
          prefixCode: item.prefixCode,
          frontendHintText: item.frontendHintText,
        }
      }

      return {
        title: (
          <span
            className="ellipsis"
            style={{ userSelect: 'none' }}
            id={titleId}
          >
            {titleName}
          </span>
        ),
        name: item.name,
        level: item.level,
        key: item.id,
        disabled: false,
        canAddProduct: item.canAddProduct,
        className: 'customtreeall',
        switcherIcon: renderIcon,
        prefixCode: item.prefixCode,
        frontendHintText: item.frontendHintText,
      }
    })
  }
  // 选中tree节点
  const onSelect = (key: (string | number)[], info: any) => {
    setSelectedKeys(key)
    selectNode({
      key: info.node.key,
      title: info.node.name,
      level: info.node.level,
      parentId: info.node.parentId,
      categoryTree: info.node.categoryTree,
      canAddProduct: info.node.canAddProduct,
      prefixCode: info.node.prefixCode,
      frontendHintText: info.node.frontendHintText,
    })
  }

  const gettreeData = () => {
    if (!ignore.current) {
      return [
        {
          title: '全部',
          key: '',
          level: '',
          name: '',
          disabled: false, // 是否禁用、启用
          className: 'customtreeall',
          switcherIcon: renderIcon,
          children: loop(treeList), // 筛选掉不可见的类目.filter(item=>item.canShow)
          prefixCode: '',
        },
      ]
    }
    return []
  }

  const renderIcon = (val: any) => {
    if (!val.data.children || val.data.children.length === 0) {
      return null
    }
    if (val.expanded) {
      return <MinusSquareOutlined />
    }
    return <PlusSquareOutlined />
  }

  return (
    <Spin spinning={loading}>
      <Tree.DirectoryTree
        treeData={gettreeData()} // treeNodes 数据
        height={height}
        onExpand={onExpand} // 展开/收起节点时触发
        expandedKeys={expandedKeys} // （受控）展开指定的树节点
        autoExpandParent={autoExpandParent} // 是否自动展开父节点
        expandAction="doubleClick" // 双击展开
        showIcon={false}
        onSelect={onSelect} // 点击树节点触发
        blockNode={false} // 是否节点占据一行
        selectedKeys={selectedKeys} // 当前选中
      />
    </Spin>
  )
}
export default CustomTreeAll
